import { Button } from "@/components/ui/button";
import useShare from "@/hooks/use-share";
import { cn } from "@/lib/utils";

function CloseIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-white", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.95 4.95l9.899 9.9m-.001-9.9l-9.9 9.9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

interface CopyNotificationProps {
  label?: string;
  onClose(): void;
}

export function CopyNotification({
  label = "Link copied to the clipboard",
  onClose,
}: CopyNotificationProps) {
  return (
    <div className="mx-auto flex h-12 w-[389px] max-w-9/10 items-center rounded-[30px] bg-white px-[11px] shadow-9-6-4 shadow-black/10">
      <p className="grow text-center text-16 text-eerie-black">{label}</p>
      <Button
        aria-label="Close"
        className="size-[35px] shrink-0 rounded-full bg-mulberry/80"
        onClick={onClose}
      >
        <CloseIcon />
      </Button>
    </div>
  );
}

interface ShareButtonProps extends React.ComponentProps<typeof Button> {
  shareData: ShareData;
}

export default function ShareButton({ shareData, ...props }: ShareButtonProps) {
  const { onShare } = useShare(shareData);

  return <Button aria-label="Share" {...props} onClick={onShare} />;
}
